import { Dropdown } from "semantic-ui-react";

import React from "react";
import { Link } from "react-router-dom";

import MenuItemContent from "../Menu/components/MenuItemContent";

export default function DropdownMenuItem({
	to,
	linkTo,
	icon,
	text,
	content,
	children,
	loading,
	label,
	labelColor,
	...props
}) {
	return (
		<Dropdown.Item as={to || linkTo ? Link : "div"} to={to || linkTo} {...props}>
			<MenuItemContent
				icon={icon}
				text={text}
				content={content}
				loading={loading}
				label={label}
				labelColor={labelColor}
			>
				{children}
			</MenuItemContent>
		</Dropdown.Item>
	);
}
